
import { Component, Emit, Prop, Ref, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { ImageUploaderUtils } from '@xt/client/utils/uploader'
import type { UploadItemType } from '@xt/client/utils/uploader/types.d'
import { reportEntryLog } from '@xt/client/utils/log'

@Observer
@Component({
  components: {}
})
export default class ImageUploader extends Vue {
  @Prop({ required: true }) max: number

  @Ref()
  uploader: HTMLInputElement

  @Ref()
  uploaderDrop: HTMLDivElement

  isDragOver: boolean = false

  counter = 0

  utils: ImageUploaderUtils | null = null

  // expose
  chooseImage() {
    if (this.uploader) {
      this.uploader.click()
    }
  }

  removeUploadTask(uid: string) {
    this.utils?.removeImage(uid)
  }

  reloadUploadTask(uid: string) {
    this.utils?.reuploadImage(uid)
  }

  handleAddImages(files: FileList) {
    Array.from(files)
      .filter(file => {
        const isTypeValid = ['image/png', 'image/jpeg'].includes(file.type.toLowerCase())
        // 尺寸是否满足20M以内的限制
        const isSizeValid = file.size < 20 * 1024 * 1024

        const isValid = isTypeValid && isSizeValid

        if (!isValid) {
          reportEntryLog('upload.image-type.error', {
            name: file.name,
            size: file.size,
            type: file.type
          })
        }

        if (!isTypeValid && !isSizeValid) {
          this.$message.error('图片大小超出 20M，图片格式需为 jpg或png')
        } else if (!isSizeValid) {
          this.$message.error('图片大小超出 20M')
        } else if (!isTypeValid) {
          this.$message.error('图片格式需为 jpg或png')
        }

        return isValid
      })
      .forEach(imageFile => {
        const reader = new FileReader()

        reader.onload = event => {
          if (event.target?.result && this.utils) {
            const success = this.utils.addImage({
              url: event.target.result as string,
              size: imageFile.size,
              name: imageFile.name,
              raw: imageFile
            })

            if (!success) {
              this.$message.error('上传图片数量超出限制')
            }
          }
        }

        reader.onerror = () => {
          console.error('reader 错误', imageFile)
        }

        reader.readAsDataURL(imageFile)
      })
  }

  handleInputChange(event: InputEvent) {
    const target = event.target as HTMLInputElement

    if (target.files) {
      this.handleAddImages(target.files)
    }
  }

  handleInputChange1(event: InputEvent) {
    ;(event.target as HTMLInputElement).value = ''
  }

  handleStatusChange(imageList: UploadItemType[]) {
    this.$emit(
      'change',
      imageList.map(item => {
        const { rawImageFile, ...rest } = item

        return rest
      })
    )
  }

  created() {
    if (!this.utils) {
      this.utils = new ImageUploaderUtils(this.max)
      this.utils.addChangeListener(this.handleStatusChange)
    }
  }
  mounted() {
    if (this.uploaderDrop) {
      this.uploaderDrop.addEventListener('dragenter', e => {
        this.counter++

        this.isDragOver = true
        e.preventDefault()
        e.stopPropagation()
      })

      this.uploaderDrop.addEventListener('dragleave', e => {
        this.counter--
        if (this.counter <= 0) {
          this.isDragOver = false
        }
        e.preventDefault()
        e.stopPropagation()
      })

      this.uploaderDrop.addEventListener('dragover', e => {
        e.preventDefault()
        e.stopPropagation()
      })

      this.uploaderDrop.addEventListener('drop', e => {
        this.counter = 0
        this.isDragOver = false
        e.stopPropagation()
        e.preventDefault()
        if (e.dataTransfer?.files) {
          this.handleAddImages(e.dataTransfer.files)
        }
      })
    }
  }
  updated() {}
  destroyed() {
    if (this.utils) {
      this.utils.removeChangeListener(this.handleStatusChange)
      this.utils = null
    }
  }
}
